import { useState, useEffect } from 'react';
import { apiCall } from '../api/client';
import type { QuorumStatusResponse } from '../api/types';

const DEFAULT_QUORUMS_POLL_MS =
  Number(import.meta.env.VITE_QUORUMS_POLL_INTERVAL_MS) || 60000;

export function useQuorums(refreshInterval = DEFAULT_QUORUMS_POLL_MS) {
  const [data, setData] = useState<QuorumStatusResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const [pollTick, setPollTick] = useState(0);

  const fetchQuorums = async () => {
    setPollTick((prev) => prev + 1);
    try {
      const status = await apiCall<QuorumStatusResponse>('/quorums/status');
      setData(status);
      setError(null);
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchQuorums();

    if (refreshInterval > 0) {
      const interval = setInterval(fetchQuorums, refreshInterval);
      return () => clearInterval(interval);
    }
  }, [refreshInterval]);

  return {
    data,
    loading,
    error,
    refetch: fetchQuorums,
    pollInterval: refreshInterval,
    pollTick,
  };
}

